import { render, staticRenderFns } from "./MediaBrowser.vue?vue&type=template&id=2ccb53d5&scoped=true&"
import script from "./MediaBrowser.vue?vue&type=script&lang=js&"
export * from "./MediaBrowser.vue?vue&type=script&lang=js&"
import style0 from "./MediaBrowser.vue?vue&type=style&index=0&id=2ccb53d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb53d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDataIterator,VDataTable,VIcon,VImg,VProgressCircular,VProgressLinear,VRow,VTooltip})
